export const Config = {
	active: true,
};
